<template>
	<v-app-bar dense color="primary" dark app id="navBar">
		<!-- <Snowf
            :amount="60"
            :size="4"
            :speed="1"
            :wind="0"
            :opacity="0.6"
            :swing="2"
            :image="null"
            :zIndex="null"
            :resize="true"
            color="#fff"
        /> -->
		<v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

		<!-- <v-toolbar-title>MásMánager</v-toolbar-title> -->

		<v-spacer v-if="!$vuetify.breakpoint.xsOnly"></v-spacer>
		<v-text-field
			hide-details
			:append-icon="navBarSearchField ? '' : 'mdi-magnify'"
			single-line
			:class="!$vuetify.breakpoint.xsOnly ? 'mr-5' : ''"
			v-if="searchBarEnabled"
			v-model="navBarSearchField"
			clearable
		></v-text-field>

		<v-spacer></v-spacer>
		<v-btn
			icon
			@click="toggleDark"
			:aria-label="$vuetify.theme.dark ? 'Switch to light mode' : 'Switch to dark mode'"
		>
			<v-icon>
				{{ $vuetify.theme.dark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}
			</v-icon>
		</v-btn>
		<v-menu left bottom :offset-y="true">
			<template v-slot:activator="{ on, attrs }">
				<v-btn icon v-bind="attrs" v-on="on" class="pr--10">
					<v-icon>mdi-account</v-icon>
				</v-btn>
				<div v-if="!$vuetify.breakpoint.xsOnly">{{ fullName }}</div>
			</template>

			<v-list>
				<v-list-item link href="/areapersonal/mizona">
					<v-list-item-title> Comunicados </v-list-item-title>
					<v-list-item-icon>
						<v-badge
							:content="communicates ? communicates : '0'"
							overlap
							color="red"
							small
						>
							<v-icon color="orange">
								mdi-email-newsletter
							</v-icon>
						</v-badge>
					</v-list-item-icon>
				</v-list-item>
				<v-list-item link href="/logout">
					<v-list-item-title> Log out </v-list-item-title>
					<v-list-item-icon>
						<v-icon color="#bb0d00">mdi-logout</v-icon>
					</v-list-item-icon>
				</v-list-item>
			</v-list>
		</v-menu>
	</v-app-bar>
</template>

<script>
import { mapState } from 'vuex';
import Snowf from 'vue-snowf';
const DARK_MODE_KEY = 'app_dark_mode';

export default {
	name: 'NavBar',
	components: {
		Snowf,
	},
	data: () => ({
		drawer: false,
	}),
	computed: {
		communicates() {
			return JSON.parse(localStorage.getItem('communicates'))?.length;
		},
		navBarSearchField: {
			get() {
				return this.$store.state.util.navBarSearchField;
			},
			set(val) {
				this.$store.commit('util/navBarSearchField', val);
			},
		},
		numnot() {
			return 1; //this.$store.state.general.NumNotifications
		},
		searchBarEnabled() {
			return this.$store.getters['util/searchBarEnabled'](
				this.$route.path
			);
		},
		...mapState('login', {
			fullName: (state) => state.nombre,
		}),
	},
    methods: {
        toggleDark() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            localStorage.setItem(DARK_MODE_KEY, this.$vuetify.theme.dark);
        },
    },
	watch: {
		drawer: {
			handler() {
				if (!this.$store.state.general.IsOpenSideBar)
					this.$store.dispatch('general/openSideBar');
				else {
					this.$store.dispatch('general/closeSideBar');
				}
			},
		},
	},
};
</script>